import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Box from '@mui/material/Box'

import { selectPageZoom } from '../pages/pagesSlice'
import {
  addSizeToStiki,
  updateDirtyStikisAsync,
  selectCurrentStikiId,
} from './stikisSlice'

import {
  selectStikisResize,
  selectResizeOffset,
  updateResize,
  endResize,
} from '../ui/uiSlice'

import { pxToEm } from '../../helpers'

export default function ResizeEventWrapper({ pageId, children }) {
  const dispatch = useDispatch()
  const currentStiki = useSelector(selectCurrentStikiId)

  ///////////////////////////////////////////////
  //
  // Local state
  //

  const zoom = useSelector(selectPageZoom(pageId))
  const stikisResize = useSelector(selectStikisResize)
  const [hasResized, setHasResized] = useState(false)
  const offset = useSelector(selectResizeOffset)

  ///////////////////////////////////////////////
  //
  // Events
  //

  const handleMouseMove = (e) => {
    if (stikisResize.isResizing) {
      // console.log('<ResizeEventWrapper/>.handleMouseMove()')
      setHasResized(true)
      dispatch(
        updateResize({
          x: pxToEm(e.pageX - stikisResize.start.x, zoom),
          y: pxToEm(e.pageY - stikisResize.start.y, zoom),
        })
      )

      e.stopPropagation()
      e.preventDefault()
    }
  }

  const handleMouseUp = (e) => {
    if (stikisResize.isResizing) {
      // console.log('<ResizeEventWrapper/>.handleMouseUp()')

      if (hasResized) {
        dispatch(
          addSizeToStiki({
            stikiId: currentStiki,
            size: offset,
          })
        )
        dispatch(updateDirtyStikisAsync(pageId))
      }
      dispatch(endResize())

      setHasResized(false)

      e.preventDefault()
      e.stopPropagation()
    }
  }

  ///////////////////////////////////////////////
  //
  // Markup
  //

  return (
    <Box
      sx={{ position: 'absolute', inset: 0 }}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      {children}
    </Box>
  )
}
